import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  guest?: core.Patron;
}

const initialState: State = {
  guest: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.UPDATE_LAST_GUEST: {
      return {
        ...state,
        guest: payload,
      };
    }
    default:
      return state;
  }
}
